module.exports = __webpack_public_path__ + "static/tour-b-main-59f374feacf3733e951623c9f89bfbbf.jpg";